module.exports = __webpack_public_path__ + "img/193.99a5447c.jpg";